/**
 * Hook para acceder a authStore. Usar en lugar de useAuthState (domain) tras migración.
 */
import useAuthStore from "../store/authStore";

export function useIsLoggedInFromAuthStore(): boolean {
    return useAuthStore((s) => s.isLoggedIn);
}

export function useSelectedRoleFromAuthStore() {
    return useAuthStore((s) => s.selectedRole);
}
